import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

const NotFoundPage = () => (
  <div className="min-h-[70vh] bg-warm-sand flex items-center justify-center px-4 py-24" data-testid="not-found-page">
    <div className="text-center max-w-md">
      <p className="font-body uppercase tracking-[0.25em] text-temple-gold text-xs mb-4">404</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-light text-charcoal mb-3">
        Page not found
      </h1>
      <p className="font-body text-charcoal-light mb-8">
        The page you&apos;re looking for doesn&apos;t exist, or it may have moved. Let&apos;s get you back to something useful.
      </p>
      <Button asChild data-testid="not-found-home-btn">
        <Link to="/">
          <Home className="w-4 h-4 mr-2" />
          Back to home
        </Link>
      </Button>
    </div>
  </div>
);

export default NotFoundPage;
